<form [formGroup]="mileageForm" class="mt-6 flex flex-col gap-4">
  <div class="flex flex-col">
    <label class="soft-label top required" for="date">Datum</label>
    <soft-date-input formControlName="date" softFieldValidation></soft-date-input>
  </div>
  <div class="flex flex-col">
    <label class="soft-label top required" for="mileage">Kilometer</label>
    <soft-number-input formControlName="mileage" softFieldValidation></soft-number-input>
  </div>
  <div class="flex flex-col">
    <label class="soft-label top required" for="operatingHours">Arbeitsstunden</label>
    <soft-number-input
      formControlName="operatingHours"
      softFieldValidation
    ></soft-number-input>
  </div>
</form>
<div class="flex gap-2 mt-4">
  <button
    type="button"
    class="soft-button outline h-14 w-full mt-4"
    (click)="this.resolve('CANCEL')"
  >
    Abbrechen
  </button>
  <button
    type="button"
    class="soft-button primary h-14 w-full mt-4"
    (click)="submit()"
    [disabled]="!mileageForm.valid"
  >
    Speichern
  </button>
</div>
